import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SalesLeaderboardPageComponent } from './sales-leaderboard-page.component';

const routes: Routes = [
  {
    path:      'sales-leaderboard',
    component: SalesLeaderboardPageComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})
export class SalesLeaderboardPageRoutingModule {
}
